import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import LocaleProvider from "../../components/LocaleProvider";

const App = ({
  store,
  translations,
  RouterComponent,
  ...routerRenderProps
}) => (
  <Provider store={store}>
    <LocaleProvider translations={translations}>
      <RouterComponent {...routerRenderProps} />
    </LocaleProvider>
  </Provider>
);

App.propTypes = {
  store: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  RouterComponent: PropTypes.any.isRequired
};

export default App;
